import moment from 'moment'

export const SET_EVENT_VIEW = 'SET_EVENT_VIEW'
export const SET_EVENT_CATEGORIES = 'SET_EVENT_CATEGORIES'
export const SET_EVENT_LOCATIONS = 'SET_EVENT_LOCATIONS'
export const SET_EVENT_START_DATE = 'SET_EVENT_START_DATE'
export const SET_EVENT_END_DATE = 'SET_EVENT_END_DATE'

// SET FILTERS
export const setView = view => dispatch => {
  dispatch({ type: SET_EVENT_VIEW, payload: view })
}

export const setCategories = categories => dispatch => {
  dispatch({ type: SET_EVENT_CATEGORIES, payload: categories })
}

export const setLocations = (locations) => dispatch => {
  dispatch({ type: SET_EVENT_LOCATIONS, payload: locations })
}

export const setStartDate = date => dispatch => {
  dispatch({ type: SET_EVENT_START_DATE, payload: date })
}

export const setEndDate = date => dispatch => {
  dispatch({ type: SET_EVENT_END_DATE, payload: date })
}

// RESET FILTERS
export const resetCategories = () => dispatch => {
  dispatch({ type: SET_EVENT_CATEGORIES, payload: [] })
}

export const resetLocations = () => dispatch => {
  dispatch({ type: SET_EVENT_LOCATIONS, payload: [] })
}

export const resetDates = () => dispatch => {
  dispatch({ type: SET_EVENT_START_DATE, payload: moment().format('YYYY-MM-DD') })
  dispatch({ type: SET_EVENT_END_DATE, payload: null })
}
